import { validateInput } from "../validation";
import { useCallback } from "react";
import { useValidateAttributePair } from "./use-validate-attribute-pair";

export const useProductValidation = (products) => {
    const validatePair = useValidateAttributePair();

    return useCallback(
        (definitions, codingWipKey) => {
            return definitions.reduce((arr, definition) => {
                let isPairInvalid = false;

                if (definition.pairedAttributes) {
                    const [pairedAttribute] = definition.pairedAttributes;

                    if (pairedAttribute && pairedAttribute.required) {
                        isPairInvalid = validatePair(
                            { value: products[codingWipKey][definition.uuid] },
                            { value: products[codingWipKey][pairedAttribute.uuid] }
                        );
                    }
                }

                const validAttribute = validateInput(products[codingWipKey][definition.uuid], definition.validation);

                if (products[codingWipKey].hasOwnProperty(definition.uuid) && !validAttribute.isValid) {
                    arr.push(definition.name);
                } else if (isPairInvalid) {
                    arr.push(definition.name);
                } else if (!products[codingWipKey].hasOwnProperty(definition.uuid) && !validAttribute.isValid) {
                    arr.push(definition.name);
                }
                return arr;
            }, []);
        },
        [products]
    );
};
